import storeList from "../../store/store-list.js";
import * as ordersApi from "../../backend/releaseOrdersApi.js";
import {
	unloadingPlaceTypes,
} from "../../enums/unloading-place-types.js";
import { eTransportTypes } from "./components/transport-types.js";
import {
	getSettings,
} from "../../backend/settingsApi.js";
import {
	getData,
} from "../../backend/dataEditorApi.js";

const list = new storeList();

const state = {
	...list.state,
	releaseOrder: {},
	releaseOrderPeriod: null,
	transportTypes: [{ value: 0, text: "Нужен поиск транспорта" },
	{ value: 1, text: "Курьерская служба" },
	{ value: 2, text: "Транспорт клиента" }],
	shippings: [],
	arrivalPlaces: [],
	needSync: false,
	disableAddNotIsPartial: false,
};
const getters = {
	...list.getters,
	releaseOrder(state) {
		return state.releaseOrder;
	},
	needSync(state) {
		return state.needSync;
	},
	transportTypes(state) {
		return state.transportTypes;
	},
	shippings(state) {
		return state.shippings;
	},
	releaseOrderPeriod(state) {
		return state.releaseOrderPeriod;
	},
	arrivalPlaces(state) {
		return state.arrivalPlaces;
	},
	arrivalTypeItems: () => {
		return [{
			value: unloadingPlaceTypes.FACTORY,
			text: "Склад продавца",
		},
		{
			value: unloadingPlaceTypes.GROUPEDWAREHOUSE,
			text: "Группажный склад",
		},
		{
			value: unloadingPlaceTypes.ADDRESS,
			text: "Другое",
		},
		{
			value: unloadingPlaceTypes.OTHERWAREHOUSE,
			text: "Другой склад",
		}];
	},
	disableAddNotIsPartial(state) {
		return state.disableAddNotIsPartial;
	},
};
const actions = {
	...list.actions,
	async getShippings({ commit }, id) {
		const result = await ordersApi.getReleaseOrdersShippings(id);
		commit("setShippings", result);
		var res = result.some((e) => e.isPartialPlan && e.isShipped);
		commit("setDisableAddNotIsPartial", res);
	},
	async getData({ commit, dispatch }, value) {
		const id = +value;
		if (!id) {
			const warehouse = await getSettings();
			const address = await getData("warehouses", false, warehouse.data.Warehouse.Id);
			commit("setReleaseOrder", {
				id: 0,
				releaseOrderPlan: "",
				releaseOrderPeriod: null,
				senderAddress: address.data.Address ? {
					id: address.data.Address.Id,
					title: address.data.Address.Title,
				} : null,
				transport: null,
				courier: null,
				transportType: eTransportTypes.CLIENTTRANSPORT,
				volume: null,
				cargoPlaces: null,
				isPartial: false,
				number: "",
				notes: "",
				arrivalPlaces: [],
			});
			commit("setArrivalPlaces", []);
			commit("setReleaseOrderPeriod", null);
			return;
		}
		const releaseOrder = await ordersApi.getReleaseOrder(id);
		commit("setReleaseOrder", releaseOrder);
		const releaseOrderPeriod = releaseOrder
			? {
				value: releaseOrder.releaseOrderPeriod.id,
				text: releaseOrder.releaseOrderPeriod.title,
			}
			: null;
		commit("setReleaseOrderPeriod", releaseOrderPeriod);
		dispatch("initArrivalPlaces", releaseOrder.arrivalPlaces);
	},
	initArrivalPlaces({ commit }, arrivalPlaces) {
		if (!arrivalPlaces.length) {
			commit("setArrivalPlaces", arrivalPlaces);
		}
		const places = arrivalPlaces.map(place => {
			return {
				id: place.id,
				title: place.address,
				address: place.address
			};
		});
		commit("setArrivalPlaces", places);
	},
};
const mutations = {
	...list.mutations,
	setReleaseOrder(state, value) {
		state.releaseOrder = value;
	},
	setNeedSync(state, value) {
		state.needSync = value;
	},
	setShippings(state, value) {
		state.shippings = value;
	},
	setReleaseOrderPeriod(state, value) {
		state.releaseOrderPeriod = value;
	},
	setArrivalPlaces(state, value) {
		state.arrivalPlaces = value;
	},
	setDisableAddNotIsPartial(state, value) {
		state.disableAddNotIsPartial = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
